import { TournamentFollowRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class UnfollowTournamentUseCase {
  constructor(private tournamentFollowRepository: TournamentFollowRepository) {}

  async execute(userId: string, tournamentId: string): Promise<void> {
    logger.debug('UnfollowTournament', 'Unfollowing tournament', { userId, tournamentId });

    await this.tournamentFollowRepository.unfollow(userId, tournamentId);

    logger.debug('UnfollowTournament', 'Tournament unfollowed successfully');
  }
}
